import { useSelector } from 'react-redux';
import {
  CVRPromoteEnrollLocales,
  USER_TYPE_GUEST
} from '@app/constants/commonConstants';
import { replaceTokensInString, replaceTokensInUrl } from '@app/utils';
import links, { headlessLinks } from '@app/constants/links';
import { PCC_HEADLESS_CAT_VANTAGE_REWARDS_ACCOUNT_PAGE } from '@app/constants/featureFlags';

const getCatVantageRewardsEnrollLink = locale =>
  CVRPromoteEnrollLocales.includes(locale)
    ? `/${locale.slice(0, 2)}/catcorp/getrewarded`
    : '/en/catcorp/getrewarded';

const useCatVantageEnrollmentLink = () => {
  const catalogId = useSelector(s => s.common?.catalogId);
  const storeId = useSelector(s => s.common?.storeId);
  const langId = useSelector(s => s.common?.langId);
  const locale = useSelector(s => s.common.locale);
  const userType = useSelector(s => s?.common.userType);
  const isLoggedIn = userType !== USER_TYPE_GUEST;
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const isHeadlessCatVantageRewardsEnabled = useSelector(
    s => s.featureFlag?.[PCC_HEADLESS_CAT_VANTAGE_REWARDS_ACCOUNT_PAGE]
  );
  const { CAT_VANTAGE_REWARDS_URL } = links;

  const catVantageRewardsMyAccountLink = isHeadlessCatVantageRewardsEnabled
    ? replaceTokensInString(
        headlessLinks.HEADLESS_CAT_VANTAGE_REWARDS,
        esiteURL
      )
    : replaceTokensInUrl(CAT_VANTAGE_REWARDS_URL, catalogId, langId, storeId);

  return isLoggedIn
    ? catVantageRewardsMyAccountLink
    : getCatVantageRewardsEnrollLink(locale);
};

export default useCatVantageEnrollmentLink;
